module.exports = __webpack_public_path__ + "img/sankaku_87_red.9b8dc8f4.png";